export default "__VITE_ASSET__Bl$JSsv$__"